// Порты и типы границы client-transport. SPEC client-transport §4.1.
//
// Изоляция (keyhole, Тир 1): браузерные API (fetch / WebSocket / IndexedDB / crypto.randomUUID /
// navigator.onLine) НЕ используются напрямую — они спрятаны за инъектируемыми портами, чтобы тесты
// подставляли фейки, а логика работала в Node без браузера. Все доменные типы — из
// @tele-chat/shared-contracts; локальных дублей DTO/событий тут нет (инвариант 4).
/** Константы readyState WebSocket (зеркало W3C: CONNECTING/OPEN/CLOSING/CLOSED). */
export const WS_CONNECTING = 0;
export const WS_OPEN = 1;
export const WS_CLOSING = 2;
export const WS_CLOSED = 3;
export const DEFAULT_BACKOFF = {
    baseMs: 500,
    maxMs: 30_000,
    factor: 2,
    jitter: 0.5,
};
//# sourceMappingURL=ports.js.map